import React, { useState } from 'react'

import {
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  Stack,
  Switch,
  TextField,
} from '@mui/material'
import { listFromCodes } from '../../Functions/ListItemGenerator'
import { Box } from '@mui/system'
import { useUserContext } from '../../Contexts/UserConfig'
import { useHoldingContext } from '../../Contexts/CurrentHolding'
import PageSection from '../../Constants&Theme/PageSection'
import { stackGap } from '../../Constants&Theme/Spacing'
import { useVesselNew } from '../../APIs/Hooks/VesselHooks'

function VesselCreate() {
  const { currentHolding } = useHoldingContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const [autogenerate, setAutogenerate] = useState(true)
  const [vesselID, setVesselID] = useState<string>('')
  const [vesselType, setVesselType] = useState<string>('PLT')
  const [vesselLocation, setVesselLocation] = useState<number | string>(
    currentHolding?.value,
  )

  const { mutate: newVessel } = useVesselNew(
    vesselLocation,
    vesselType,
    vesselID,
  )

  const vesselTypes = listFromCodes(
    loginConfig,
    'VesselTypeID',
    loadingConfig,
    'PLT',
  )
  const holdings = listFromCodes(
    loginConfig,
    'KV-Holdings',
    loadingConfig,
    currentHolding?.value,
  )
  const valid = autogenerate || vesselID

  return (
    <Box
      sx={{
        maxWidth: 500,
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Create Vessel'}>
        <Stack
          gap={stackGap.col}
          width={1}
        >
          <Stack
            direction={'row'}
            gap={stackGap.row}
            width={1}
          >
            <FormControlLabel
              sx={{ width: 1 }}
              control={
                <Switch
                  checked={autogenerate}
                  onChange={(e) => {
                    setAutogenerate(e.target.checked)
                  }}
                  color="primary"
                />
              }
              labelPlacement="start"
              label="Autogenerate Vessel ID?"
            />
            <TextField
              fullWidth
              disabled={autogenerate}
              autoFocus
              required
              error={!valid}
              id="vesselID"
              placeholder={autogenerate ? 'Will be generated' : 'Please enter'}
              value={vesselID}
              onChange={(e) => {
                setVesselID(e.target.value)
              }}
            />
          </Stack>
          <FormControl fullWidth>
            <InputLabel>Vessel Type</InputLabel>
            <Select
              label="Vessel Type"
              aria-label={'Vessel Type'}
              value={vesselType}
              onChange={(e) => setVesselType(e.target.value)}
            >
              {vesselTypes}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Vessel Location</InputLabel>
            <Select
              label="Vessel Location"
              aria-label={'Vessel Location'}
              value={vesselLocation}
              onChange={(e) => setVesselLocation(e.target.value)}
            >
              {holdings}
            </Select>
          </FormControl>
          <Box sx={{ width: 1, display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              disabled={!valid}
              onClick={() => newVessel()}
            >
              Create Vessel
            </Button>
          </Box>
        </Stack>
      </PageSection>
    </Box>
  )
}

export default VesselCreate
